// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip--tooltip--txU+8","label":"Tooltip--label--uMZ7d","arrow":"Tooltip--arrow--KDvP8"};